module.exports = __webpack_public_path__ + "img/left-arm_active.8dd27deb.png";